<template>
    <div class="row my-3">
        <div class="card w-100">
            <div class="card-header d-flex justify-content-between">
                <p>Pop-Up manager : {{ this.language }}</p>
            </div>
            <div class="card-body d-flex flex-row flex-wrap">
                <div class="col-lg-4">
                    <div v-if="popup.imageSrc" class="card-body height-150">
                        <img
                            v-bind:src="popup.imageSrc"
                            class="img-thumbnail mh-100"
                            alt
                        />
                        <br />
                        <div
                            @click="removePopupImg()"
                            class="btn btn-danger btn-sm m-t-10"
                        >
                            <i class="fas fa-trash"></i>
                        </div>
                    </div>
                    <div
                        v-if="!popup.imageSrc"
                        @click="imageOpenDialog('image-popup')"
                        class="btn btn-success btn-sm m-t-10"
                    >
                        <i class="fas fa-plus"></i> Зураг оруулах
                        <input
                            type="file"
                            accept="image/*"
                            id="image-popup"
                            class="btn btn-primary"
                            @change="onPopupImageInput($event, true)"
                            hidden
                        />
                    </div>
                </div>
                <div class="col-lg-8">
                    <form>
                        <div class="form-group row">
                            <label for="title" class="col-sm-2 col-form-label"
                                >Гарчиг</label
                            >
                            <div class="col-sm-10">
                                <input
                                    type="text"
                                    class="form-control"
                                    id="title"
                                    v-on:input="
                                        onPopupChangeHandler('title', $event)
                                    "
                                    :value="popup.title"
                                />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="content" class="col-sm-2 col-form-label"
                                >Агуулга</label
                            >
                            <div class="col-sm-10">
                                <textarea
                                    type="text"
                                    class="form-control"
                                    id="content"
                                    v-on:input="
                                        onPopupChangeHandler('content', $event)
                                    "
                                    :value="popup.content"
                                />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="url" class="col-sm-2 col-form-label"
                                >Холбоос</label
                            >
                            <div class="col-sm-10">
                                <input
                                    type="text"
                                    class="form-control"
                                    id="url"
                                    v-on:input="
                                        onPopupChangeHandler('url', $event)
                                    "
                                    :value="popup.url"
                                />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label
                                for="buttontext"
                                class="col-sm-2 col-form-label"
                                >Холбоос товч текст</label
                            >
                            <div class="col-sm-10">
                                <input
                                    type="text"
                                    class="form-control"
                                    id="buttontext"
                                    v-on:input="
                                        onPopupChangeHandler(
                                            'buttontext',
                                            $event
                                        )
                                    "
                                    :value="popup.buttontext"
                                />
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="card-footer d-flex justify-content-end">
                <button
                    @click="onPopupSubmit('save')"
                    type="button"
                    class="btn btn-success mx-2"
                >
                    <i class="fa fa-dot-circle-o"></i> Хадгалах
                </button>
                <button
                    @click="onPopupSubmit('delete')"
                    type="button"
                    class="btn btn-danger mx-2"
                >
                    <i class="fa fa-dot-circle-o"></i> Устгах
                </button>
                <button
                    v-if="
                        popup.isPublished == 'false' && popup.isFull == 'true'
                    "
                    @click="onPopupSubmit('publish')"
                    type="button"
                    class="btn btn-primary mx-2"
                >
                    <i class="fa fa-dot-circle-o"></i> Нийтлэх
                </button>
                <button
                    v-if="popup.isPublished == 'true'"
                    @click="onPopupSubmit('unpublish')"
                    type="button"
                    class="btn btn-danger mx-2"
                >
                    <i class="fa fa-dot-circle-o"></i> Зогсоох
                </button>
                <a
                    v-if="popup.isFull == 'true'"
                    href="http://u-money.mn/?popup_preview=true"
                    target="_blank"
                    type="button"
                    class="btn btn-warning mx-2"
                >
                    <i class="fa fa-dot-circle-o"></i> Үзэх
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import DesignService from "@/services/DesignService";
import ImageUploadService from "@/services/ImageUploadService";

export default {
    name: "PopupCard",

    props: ["language"],

    created() {
        this.$store.dispatch("setLoading", true);
        this.getDesign();
    },

    data() {
        return {
            popup: {},
        };
    },

    methods: {
        imageOpenDialog(elementid) {
            document.getElementById(elementid).click();
        },
        getDesign() {
            DesignService.getDesign({})
                .then((response) => {
                    if (response.status == 200 && response.data.success == true)
                        this.design = response.data.payload;
                    this.showToast(response.data.payload.toast);

                    response.data.payload.forEach((value) => {
                        if (value.name == this.language) {
                            this.popup = JSON.parse(value.value);
                        }
                    });

                    this.$store.dispatch("setLoading", false);
                })
                .catch((error) => {
                    this.showToast(error);
                    this.$store.dispatch("setLoading", false);
                });
        },

        removePopupImg() {
            delete this.popup.imageSrc;
            this.$forceUpdate();
        },

        onPopupImageInput(event) {
            if (event.target.files[0] != null) {
                this.$store.dispatch("setLoading", true);
                const data = new FormData();

                data.append("image", event.target.files[0]);

                ImageUploadService.uploadImage(data)
                    .then((response) => {
                        this.popup.imageSrc = response.data;

                        this.$store.dispatch("setLoading", false);
                        this.$forceUpdate();
                    })
                    .catch((error) => {
                        this.showToast(error);
                        this.$store.dispatch("setLoading", false);
                    });
            }
        },

        onPopupChangeHandler(key, event) {
            this.popup[key] = event.target.value;
        },

        onPopupSubmit(type) {
            if (type == "delete") {
                this.popup = {};
            }

            // TODO : fix it later
            if (
                this.popup.title &&
                this.popup.content &&
                this.popup.imageSrc &&
                this.popup.url &&
                this.popup.buttontext &&
                this.popup.title != "" &&
                this.popup.content != "" &&
                this.popup.imageSrc != "" &&
                this.popup.url != "" &&
                this.popup.buttontext
            ) {
                this.popup.isFull = "true";
            } else {
                this.popup.isFull = "false";
            }

            if (type == "save" || type == "unpublish" || type == "delete") {
                this.popup.isPublished = "false";
            } else if (type == "publish") {
                this.popup.isPublished = "true";
            }

            this.$store.dispatch("setLoading", true);

            DesignService.setPopupDesign({}, this.language, this.popup)
                .then((response) => {
                    if (
                        response.status == 200 &&
                        response.data.success == true
                    ) {
                        this.showToast(response.data.payload.toast);
                        this.$store.dispatch("setLoading", false);
                    }
                    this.$store.dispatch("setLoading", false);

                    this.$forceUpdate();
                })
                .catch((error) => {
                    this.showToast(error);
                    this.$store.dispatch("setLoading", false);
                    this.serverErrors = error.response.data.payload.errors;
                    this.$v.$touch();
                });
        },
    },
};
</script>
